import * as React from "react";

function SvgSave(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0H16.4222L20 3.67676V18C20 19.1046 19.1046 20 18 20H2C0.89543 20 0 19.1046 0 18V2C0 0.89543 0.89543 0 2 0ZM15.5778 2H15V8H5V2H2V18H4V10H16V18H18V4.48925L15.5778 2ZM7 6V2H13V6H7ZM6 12V18H14V12H6ZM12 3H10V5H12V3Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgSave;
